module.exports = __webpack_public_path__ + "img/ClickForSound_23.1a57cddc.png";